import paths from 'redux/paths';
import client from 'helpers/client';
import mvpAuth from "../../../helpers/mvpAuth";


export const getTecdPackages = () => async (dispatch) => {
    try {
        const data = await client.sendRequest({
            path: 'tecd-packages',
            method: 'GET',
            params: {},
            // headers: mvpAuth.getHeaderForMvp(),
        })
        return { success: true, data };
    } catch (e) {
        return { success: false, error: e.message };
    }
}
export const getTecdPackageById = (packageId) => async (dispatch) => {
    // console.log("packageId", packageId);
    try {
        const response = await client.sendRequest({
            path: `tecd-packages/${packageId}`,
            method: 'GET',
            params: {},
            // headers: mvpAuth.getHeaderForMvp(),
        });
        if (response.status === 'ERROR' && response.statusCode === 400) {
            return { success: false, error: response.message };
        }
        return { success: true, data: response };
    } catch (e) {
        return { success: false, error: e.message };
    }
};
export const getWalletSessionByUserId = (userId) => async (dispatch) => {
    // console.log("packageId", packageId);
    try {
        const response = await client.sendRequest({
            path: `mvp/get-wallet-session-by-user-id/${userId}`,
            method: 'GET',
            params: {},
            headers: {
                'Content-Type': 'application/json',
                ...mvpAuth.getHeaderForMvp(), // Uncomment this line if authentication header is required
            },
        });
        if (response.status === 'ERROR' && response.statusCode === 400) {
            return { success: false, error: response.message };
        }
        return { success: true, data: response };
    } catch (e) {
        return { success: false, error: e.message };
    }
};
export const getDaoDetailByCode = (code) => async (dispatch) => {
    console.log("DAO Code", code);
    try {
        const data = await client.sendRequest({
            path: `daos/code/${code}`,
            method: 'GET',
            params: {},
            // headers: mvpAuth.getHeaderForMvp(),
        });
        return { success: true, data };
    } catch (e) {
        return { success: false, error: e.message };
    }
};
export const getKatUSDTQuote = () => async (dispatch) => {
    try {
        const data = await client.sendRequest({
            path: 'quotes',
            method: 'GET',
            params: {},
            // headers: mvpAuth.getHeaderForMvp(),
        })
        return { success: true, data };
    } catch (e) {
        return { success: false, error: e.message };
    }
}
export const registerPackage = (dataRequest) => async (dispatch) => {
    try {

        const data = await client.sendRequest({
            path: '/mvp/register-package',
            method: 'POST',
            params: JSON.stringify(dataRequest),
            headers: {
                'Content-Type': 'application/json',
                ...mvpAuth.getHeaderForMvp(), // Uncomment this line if authentication header is required
            },
        });
        return { success: true, data };
    } catch (e) {
        return { success: false, error: e.message };
    }
};